'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var styles = {
  "startFade": "Polaris-Frame-CSSAnimation--startFade",
  "endFade": "Polaris-Frame-CSSAnimation--endFade"
};

exports.default = styles;
